export default {
  bind: (el) => {
    const elems = document.querySelectorAll('input, textarea, select');
    elems.forEach(e => {
      e.setAttribute('tabindex', '-1');
    });

    el.addEventListener('focus', () => {
      elems.forEach(e => {
        e.setAttribute('readonly', 'readonly');
      });

      el.removeAttribute('readonly');
    });
    el.addEventListener('blur', () => {
      elems.forEach(e => {
        e.removeAttribute('readonly');
      });
    });
  },
};
